/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSocialGatheringTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSocialGathering,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Gather and Connect!",
    "Social Gathering Awaits!",
    "Fun and Friendship for Everyone!",
  ],
  title: "Social Gathering",
  description: "Organize a fun social gathering.",
  longDescription:
    "Gather your friends for an exciting social event! Choose a date, decide on activities, and plan refreshments!",
  emoji: "🥳",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Social Gathering",
          emoji: "🥳",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the social gathering?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to include?",
            description:
              "What activities should we focus on during the gathering?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🎈",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we prepare for the gathering?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Gather and Connect!",
    outroDescription: "Your social gathering plans are set! Enjoy the fun!",
  },
};
